<template>
  <div
    style=" display: flex; flex-direction: column;padding: 0.5rem; border-width: 1px;border-style: dashed;
    border-color: #BBBBBB;  border-radius: 5px;position: relative;  "
  >
    <div style="display: flex;gap: 0.5rem; ">
      <div style="width: 40px;min-width: 40px;height: 40px;display: flex;">
        <el-image :src="file.fileIcon" style="width: 100%;height: 100%;" />
      </div>
      <div style="display: flex; align-items: center; overflow: hidden;">
        <div class="text-truncate-1">
          {{ fileName }}
        </div>
      </div>
    </div>
    <div
      style="display: flex; justify-content: space-between; overflow: hidden;"
    >
      <div class="mt-2">
        <div style="color: #6c757d;font-size: 12px;">
          {{ file.fileSizeText }}
        </div>
      </div>
      <div style="display: flex;gap: 0.5rem; align-items: center; ">
        <div
          style="width: 35px;height: 35px; display: flex;align-items: center;justify-content: center;border: 1px solid #F1F1F4;border-radius: 5px;cursor: pointer;"
          @click="onPreview(file)"
        >
          <i class="el-icon-view tool-btn" @click="onPreview(file)"></i>
        </div>

        <div
          style="width: 35px;height: 35px; display: flex;align-items: center;justify-content: center;border: 1px solid #F1F1F4;border-radius: 5px;cursor: pointer;"
          @click="onDownload(file)"
        >
          <i class="el-icon-download tool-btn" @click="onDownload(file)"></i>
        </div>
      </div>
    </div>
    <div class="flex justify-between items-end gap-6">
      <div class="flex items-center">
        <template v-if="form.uploader">
          <el-avatar :size="24" :src="file.createByAvatarUrl" class="mr-6px"
            >U</el-avatar
          >
          <span class="text-xs color-#8E8E8E">
            {{ file.createByName || '--' }}
          </span>
          <span class="text-xs color-#8E8E8E mx-1">
            <span>At: </span>{{ file.createTime || '--' }}
          </span>
        </template>
      </div>
    </div>
    <div
      v-if="form.group"
      class="pos-absolute bottom--1px right--1px bg-#28A745 px-8px border-rd-br-5px"
    >
      <span class="text-11px font-bold color-#FFFFFF">{{
        file.attachmentTypeText
      }}</span>
    </div>
  </div>
</template>

<script>
// import { sizeOf } from '@/libs/util'

export default {
  name: 'FileListItem',
  props: {
    disabled: { type: Boolean, default: true },
    file: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultLayout: {
        preview: true,
        download: true,
        delete: false,
        size: true,
        uploader: false,
        group: false,
      },
    }
  },
  computed: {
    mergedLayout() {
      return Object.assign({}, this.defaultLayout, this.form)
    },
    fileName() {
      return this.file.fileName || this.getFileName(this.file.fileUrl)
    },
  },
  methods: {
    getFileName(fileUrl) {
      if (!fileUrl) return ''
      return fileUrl.split('/').pop()
    },

    onDownload({ fileCode }) {
      console.log('onDownload', fileCode)

      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    onPreview({ fileCode }) {
      console.log('onPreview', fileCode)
      this.$api.SYS_FILEDOWNLOAD(fileCode, { preview: true, isAutoDown: true })
    },

    onDelete() {
      this.$emit('delete', this.file)
    },
  },
}
</script>
<style lang="scss" scoped>
.text-truncate-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
